/** * @author FightFastest * @date 17/2/2022 下午 1:56 */

<template>
	<div class="answer-board">
		<vue-drag-resize
			v-for="(item, index) in answerList"
			:key="index"
			class="answer-font"
			:x="20 + (index % 4) * 300"
			:y="Math.floor(index / 4) * 100 + 100"
			:w="260"
			:h="40"
			:isResizable="true"
			:isActive="false"
			>{{ item }}
		</vue-drag-resize>
	</div>
</template>

<script>
import VueDragResize from 'vue-drag-resize'
export default {
	name: 'answerBoard',
	components: { VueDragResize },
	data() {
		return {
			//答案列表
			answerList: []
		}
	},
	mounted() {
		this.eventBus.$on('answerChange', cb => {
			if (cb) {
				this.getAnswer()
			}
		})
	},
	methods: {
		concludeWidth() {
			return this.answerList.length * 50 + 30
		},
		// 获取答案列表
		getAnswer() {
			const query = this.$route.query
			const params = {
				examId: query.examId,
				subjectId: query.examSubjectId,
				taskId: query.paperTextTaskId
			}
			this.$post('/api/querySubjectiveAnswer', params).then(res => {
				let answerList = []
				res.data.forEach(resp => {
					resp.topicTextTaskDTOS.forEach(ele => {
						answerList.push(`${ele.topicName}. ${ele.answer}`)
					})
				})
				this.answerList = answerList
			})
		}
	}
}
</script>

<style scoped lang="less">
.answer-board {
	min-width: 100px;
	min-height: 50px;
	height: 100%;
	width: 100%;
	border: none;
	.answer-font {
		font-size: 23px;
		color: red;
		font-weight: bolder;
		&:hover {
			cursor: pointer;
		}
	}
}
</style>
